module.exports = __webpack_public_path__ + "media/assets/icons/archive-fa8ddf9fef416892785b3e0a881757a5.svg";